import Typography from "@mui/material/Typography";

import RouterLink from "../../../../common/components/RouterLink";
import { RouteEnum } from "../../../../common/models/enums";
import TlmDataHubIcon from "./../icons/TlmDataHubIcon";
import DataHubGridItem from "./DataHubGridItem";
import { IModelGridItemProps } from "./GasLeakGridItem";

const TlmDataGridItem = ({ nonAdmin }: IModelGridItemProps): JSX.Element => {
  return (
    <RouterLink
      to={
        nonAdmin ? RouteEnum.SensoryTelemetryTlm : RouteEnum.TelemetryTankLevel
      }
    >
      <DataHubGridItem>
        <TlmDataHubIcon />
        <Typography variant="body2Bold">Tank Level</Typography>
      </DataHubGridItem>
    </RouterLink>
  );
};

export default TlmDataGridItem;
